module.exports = __webpack_public_path__ + "img/code.8a80d4ed.png";